import React, { createContext, ReactNode, useCallback, useContext, useState } from "react";

interface WizardContextValue {
  isWizardOpen: boolean;
  openWizard: () => void;
  closeWizard: () => void;
}

export const WizardContext = createContext<WizardContextValue | null>(null);

export const WizardProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);

  const openWizard = useCallback(() => setIsWizardOpen(true), []);
  const closeWizard = useCallback(() => setIsWizardOpen(false), []);

  return (
    <WizardContext.Provider value={{ isWizardOpen, openWizard, closeWizard }}>
      {children}
    </WizardContext.Provider>
  );
};

export const useWizard = (): WizardContextValue => {
  const ctx = useContext(WizardContext);
  if (ctx === null) {
    throw new Error("useWizard must be used within a WizardProvider");
  }
  return ctx;
};
